import { useStreamingPrompt } from "@zapier/streaming";
import { useEffect, useRef } from "react";
import { useIsCopilotNoPilotDisabled } from "@zapier/canvas-state";

export function useExecuteAiPrompt(prompt: string) {
  const { submitPrompt } = useStreamingPrompt();
  const isCopilotNoPilotDisabled = useIsCopilotNoPilotDisabled();
  const copilotTreatmentsNotReady = isCopilotNoPilotDisabled === undefined;

  // For some odd reason, this effect runs twice in local env, not on staging or prod
  // This ref is used to prevent the effect from running twice
  const hasEffectRun = useRef(false);
  useEffect(() => {
    // Exit if the effect has already run
    if (hasEffectRun.current || copilotTreatmentsNotReady) return;
    const handleSubmit = async () => {
      if (prompt) {
        try {
          await submitPrompt(prompt);
        } catch (error) {
          console.error(`Error executing prompt "${prompt}":`, error);
        }
      }
    };

    void handleSubmit();

    hasEffectRun.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prompt, copilotTreatmentsNotReady]);
}
